import {CenteredModal} from '~/components';
import {Link} from "react-router-dom";
import React, {Fragment} from "react";
const UpgradePlanRequest = ({
                                showModal = false,
                                setShowModal,
                                typeId = 0
                            }) => {
    return (
        <CenteredModal
            show={showModal}
            title="Feature Locked"
            onClose={() => setShowModal(false)}
            closeText="Close"
        >
            <div className="text-center">
                {
                    typeId == 1 && (
                        <Fragment>
                            <p className="fs-8-1 fw-bold mb-2">
                                Your time usage period has ended.
                            </p>
                            <p className="text-body-tertiary fs-9 mb-0">
                                Please upgrade to a paid plan to continue using our services.
                            </p>
                        </Fragment>
                    )
                }
                {
                    typeId == 2 && (
                        <Fragment>
                            <p className="fs-9 fw-bold mb-2">
                                <span className="text-dark">Audio Playback and Voice Chat</span>
                                <span className="text-primary"> are not available in your current plan.</span>
                            </p>

                            <p className="text-body-tertiary fs-9 mb-0">
                                Unlock real-time voice interaction and audio responses.
                                <br/>Upgrade to access this exclusive feature.
                            </p>
                        </Fragment>
                    )
                }
                {
                    typeId == 3 && (
                        <Fragment>
                            <p className="fs-9 fw-bold mb-2">
                                <span className="text-dark">Multiple language chat support</span>
                                <span className="text-primary"> is not included in your current plan.</span>
                            </p>

                            <p className="text-body-tertiary fs-9 mb-0">
                                Your current plan allows communication in English only.
                                <br/>Upgrade your plan to unlock this exclusive feature and enhance your experience.
                            </p>
                        </Fragment>
                    )
                }
                <Link
                    onClick={() => setShowModal(false)}
                    to="/ai-chatbot/upgrade-plan"
                    className="nav-link fs-9 mt-3 text-primary text-decoration-underline"
                >
                    Upgrade Here
                </Link>
            </div>
        </CenteredModal>
    )
}
export default UpgradePlanRequest